import { useState, useEffect } from 'react';
import { matchPath, useLocation } from 'react-router';

import { paths } from 'src/routes/paths';

import { useResponsive } from 'src/hooks/use-responsive';

export const useTabs = (permission: string) => {
  const location = useLocation();
  const [value, setValue] = useState(2);
  const responsive = useResponsive;

  useEffect(() => {
    const {pathname} = location;

    if (matchPath(paths.home.root, pathname)) {
      setValue(2);
    } else if (matchPath(paths.benefits.root, pathname)) {
      setValue(1);
    } else if (matchPath(paths.user.profile, pathname)) {
      setValue(0);
    } else {
      setValue(0);
    }
  }, [location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const TabsHook: any = {
    value,
    handleChange,
    responsive,
  };

  return TabsHook;
};
